const knownDepartments = ['Urologia', 'Ginecologia', 'Pediatria'];

export const getKnownDepartments = () => knownDepartments;

export const isIcuEntryOpen = (entry) => !(entry.leftAt || entry.left_at || entry.fecha_salida || entry.left);

export const buildPatientViewModel = (patient) => {
  const icuEntries = patient.icuEntries || patient.icu_entries || patient.icu_entries_list || [];
  const hasOpenIcu = icuEntries.some(isIcuEntryOpen);
  const en_uci = Boolean(patient.en_uci || hasOpenIcu);
  const estado = patient.estado || (en_uci ? 'uci' : 'hospitalizado');

  return {
    id: patient.id,
    nombre: `${(patient.firstName || '').trim()} ${(patient.lastName || '').trim()}`.trim(),
    historia_clinica: patient.medicalRecordNumber || patient.medical_record_number || '',
    edad: patient.edad || (patient.birthDate ? Math.max(0, new Date().getFullYear() - new Date(patient.birthDate).getFullYear()) : null),
    diagnostico: patient.notes || null,
    habitacion: patient.habitacion || null,
    en_uci,
    estado,
    department: patient.department || patient.departamento || null,
    raw: patient,
  };
};

export const getPatientDisplayName = (patient) => {
  if (!patient) return '';
  if (patient.nombre) return patient.nombre;
  return `${(patient.firstName || '').trim()} ${(patient.lastName || '').trim()}`.trim();
};

export const sortIcuEntries = (entries = []) => {
  return [...entries].sort((a, b) => {
    const aTime = new Date(a.enteredAt || a.fecha_entrada || a.createdAt || 0).getTime();
    const bTime = new Date(b.enteredAt || b.fecha_entrada || b.createdAt || 0).getTime();
    return bTime - aTime;
  });
};
